export function truncateTextByCharacters(text = '', maxLength) {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + '...'
  } else {
    return text
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/text/index.js